import http from '@utils/http'


// 查询号卡信息
export function getSimInfo(data: any): Promise<any> {
    return http.post('https://aoac.lenovoconnect.com/sim/simInfo', data || {})
}

// 查询号卡使用情况
export function getObtainTerminalUsage(data: any): Promise<any> {
    return http.post('https://aoac.lenovoconnect.com/sim/obtainTerminalUsage', data || {})
}

// 查询号卡推荐套餐
export function getQueryGoodsShelfInfo(data: any): Promise<any> {
    return http.post('https://aoac.lenovoconnect.com/sim/queryGoodsShelfInfo', data || {})
}